import React from 'react';
import { Link } from 'react-router-dom';

const ProductImage = ({
  productImage,
  url,
  target,
  dittoClasses,
  dittoSubClass,
  dittoStyle,
  anchorClass,
}) => {
  return (
    <>
      {/* <Link className={`no-decoration display-block ${dittoSubClass}`} target={target} to={url}> */}
      <Link className={`no-decoration display-block ${anchorClass}`} target={target} to={url}>
        <div className={`col-md-12 text-center ${dittoClasses}`}>
          <div className={`pos-abs ${dittoSubClass}`} style={dittoStyle}>
            &nbsp;
          </div>
          {productImage}
        </div>
      </Link>
    </>
  );
};

export default ProductImage;
